import { render, staticRenderFns } from "./CustomerListTable.vue?vue&type=template&id=67c726eb&scoped=true&lang=pug"
import script from "./CustomerListTable.vue?vue&type=script&lang=js"
export * from "./CustomerListTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerListTable.vue?vue&type=style&index=0&id=67c726eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c726eb",
  null
  
)

export default component.exports